import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../hooks/hooks';
import { setSource, Source, StorageSpaceTypes } from '../../cdsSlice';
import { useAtlasCdsQuery } from '../../cdsApiSlice';
import './MainSourceExterne.scss';
import { useNavigate } from 'react-router-dom';
import RenderLoading from './RendorLoading';
import ButtonsNavigate from './BottomButtonNaviage';
import { Message } from 'primereact/message';
import { useTranslation } from 'react-i18next';

interface StockageProps {
    add: () => void;
    minus: () => void;
}

interface Error {
    espaceDeStockage: boolean;
}

export const Stockage = ({add, minus}: StockageProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const source: Source = useAppSelector((state) => state.cds.source);

    // Get EDS for S3 and Kafka
    const {data: atlasS3, ...dataStatusS3} = useAtlasCdsQuery({type: StorageSpaceTypes.S3});
    const [edsName, setEdsName] = useState(source.espaceDeStockageName);
    const [storageSpace, setStorageSpace] = useState(source.choiceEspaceDeStockage === "KAFKA" ? StorageSpaceTypes.KAFKA : StorageSpaceTypes.S3) ;

    const s3 = require('../../../../assets/images/SelectamazonS3.svg');
    const kafka = require('../../../../assets/images/Selectkafka.svg');
    const Logokafka = require('../../../../assets/images/Logokafka.svg');
    const Logos3 = require('../../../../assets/images/Logos3.svg');
    const [errorForm, setErrorForm] = useState<Error>({
        espaceDeStockage: false,
    });
    const navigate = useNavigate();


    const handleChangeStorageSpace = (name: StorageSpaceTypes) => {
        setStorageSpace(name);
        setEdsName(null);
    }

    const check = () => {
        if (edsName && atlasS3) {
            add();
            const eds = atlasS3.find((i: any) => i.nom === edsName);
            const stockage = {
                nom: edsName,
                guid: eds?.guid,
            };


            dispatch(
                setSource({
                    choiceEspaceDeStockage: storageSpace,
                    espaceDeStockageValue: stockage,
                    espaceDeStockageName: edsName
                })
            );
        } else {
            setErrorForm({
                espaceDeStockage: true,
            });
        }
    };

    const TemplateSelected = (option: any) => {
        if (option) {
            return (
                <div className="grid p-fluid mt-2">
                    {storageSpace === StorageSpaceTypes.S3 ? (
                        <img src={Logos3.default} alt="S3"/>
                    ) : (
                        <img src={Logokafka.default} alt="KAFKA"/>
                    )}

                    <div className="col-5">
                        <b>{option.qName}</b>
                    </div>
                    <div className="col-5">
                        <b>{option.nom}</b>
                    </div>
                </div>
            );
        }
        return <div>{''}</div>;
    };

    const Template = (option: any) => {
        if (option) {
            return (
                <div className="flex flex-wrap mt-2">
                    {storageSpace === StorageSpaceTypes.S3 ? (
                        <img src={Logos3.default} alt="S3"/>
                    ) : (
                        <img src={Logokafka.default} alt="KAFKA"/>
                    )}
                    <div>{option.nom}</div>
                </div>
            );
        }
        return;
    };

    function StorageSpaceIcon({storageSpaceName}: { storageSpaceName: StorageSpaceTypes }) {
        const style = storageSpace === storageSpaceName ? {border: 'solid 2px #007eae'} : {border: 'solid 1px #d0ddea'}

        return <div className="col-2" key={storageSpaceName}>
            <img src={storageSpaceName === StorageSpaceTypes.S3 ? s3.default : kafka.default}
                 onClick={() => handleChangeStorageSpace(storageSpaceName)}
                 style={style} alt="EDS"
            />
        </div>
    }

    return (
        <>
            {!dataStatusS3.isLoading  && atlasS3  && (
                <div className="contentForm">
                    <form className="formSourceExt">
                        <label
                            htmlFor="protocole"
                            className={classNames({
                                'p-error': false,
                                labelSourceExterne: true,
                            })}
                        >
                            {t("storage.type")}<span className="star">*</span>
                        </label>

                        <div className="grid p-fluid mt-2">
                            {atlasS3 && <StorageSpaceIcon storageSpaceName={StorageSpaceTypes.S3}/>}
                            {atlasS3 && <StorageSpaceIcon storageSpaceName={StorageSpaceTypes.KAFKA}/>}
                        </div>

                        <div className="mt-2">
                            <label
                                htmlFor="EspaceDeStockage"
                                className={classNames({
                                    'p-error':
                                        errorForm.espaceDeStockage &&
                                        edsName === null,
                                    labelSourceExterne: true,
                                })}
                            >
                                {t("storage.name")}<span className="star">*</span>
                            </label>
                            <Dropdown
                                id={'espaceDeStockage'}
                                value={edsName}
                                onChange={(e) => {
                                    setEdsName(e.value);
                                    setErrorForm({
                                        espaceDeStockage: false,
                                    });
                                }}
                                options={ atlasS3.filter((item) => item.type === storageSpace.toLocaleLowerCase()) }
                                optionLabel="qName"
                                optionValue="nom"
                                className={classNames({
                                    'p-invalid':    
                                        errorForm.espaceDeStockage &&
                                        edsName === null,
                                    fieldSourceExt: true,
                                })}
                                filter
                                showClear={false}
                                itemTemplate={Template}
                                valueTemplate={
                                    edsName ? TemplateSelected : ''
                                }
                            />
                        </div>
                    </form>
                </div>
            )}
            {(dataStatusS3.isLoading) && (
                <div className="contentForm">
                    <div className="formSourceExt mr-5">{RenderLoading(5)}</div>
                </div>
            )}

            {(dataStatusS3.isError) && (
                <div className="contentForm">
                    <div className="formSourceExt m-5">
                        <Message
                            className="w-full"
                            severity="error"
                            text={t("storage.error_loading")}
                        />
                    </div>
                </div>
            )}

            <ButtonsNavigate
                cancel={() => {
                    navigate('/library/sources');
                }}
                back={() => {
                    minus();
                    dispatch(
                        setSource({
                            choiceEspaceDeStockage: storageSpace,
                            espaceDeStockageName: edsName,
                        })
                    );
                }}
                shouldGoNext={true}
                next={() => {
                    check();
                }}
            />
        </>
    );
};
